import { useEffect } from 'react'
import { useSession } from './SessionProvider'
import { useGetUserProfileByAddress } from '@/api/query'
import { getAvatarUrl } from '@/helpers/getAvatarUrl'
import posthog from 'posthog-js'
import { useTRPCClient } from '@/api/trpc/context'
import { INTERCOM_APP_ID } from '@/constants/constants'
import { delay } from '@/helpers/delay'

export const IntercomProvider = () => {
  const { account } = useSession()

  const { data: profileData } = useGetUserProfileByAddress(account?.injectiveAddress as any)

  const trpc = useTRPCClient()

  useEffect(() => {
    if (!account?.injectiveAddress || !profileData?.user || account.privateKey_expiry < Date.now()) {
      return
    }

    delay(5000).then(() => {
      if (!window?.$chatwoot) {
        return
      }
      window?.$chatwoot?.setUser(account.injectiveAddress, {
        name: profileData?.user?.profileUserName || account.injectiveAddress,
        avatar_url: getAvatarUrl(profileData?.user!.profileAvatar!),
      })

      window?.$chatwoot?.setCustomAttributes({
        deviceId: posthog.get_property('$device_id'),
      })
    })
  }, [account, profileData])

  return null
}
